import styled from 'styled-components'

export const NameCell = styled.div(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  gap: theme.space['12'],
  minWidth: 0,
}))
